import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    const effectiveType = type === "number" ? "text" : type
    const numberInputProps = type === "number"
      ? {
          lang: "en-US",
          inputMode: "decimal" as const,
          autoComplete: "off",
          onInput: (e: React.FormEvent<HTMLInputElement>) => {
            const el = e.currentTarget
            if (el.value.includes(",")) {
              el.value = el.value.replace(/,/g, ".")
            }
            ;(props.onInput as ((evt: React.FormEvent<HTMLInputElement>) => void) | undefined)?.(e)
          },
        }
      : {}

    return (
      <input
        type={effectiveType}
        {...numberInputProps}
        className={cn(
          "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
